import { createGenericContext } from './createGenericContext'
import type { TripQueryState } from '../types/trip'

// The search a reviewer last submitted on /trips. It lives above the router
// because the results page unmounts on the way to a trip's detail page, and a
// reviewer who comes back is still paging the same results. Its lifetime is
// the page's, like the React Query cache holding those rows: a reload restores
// the form from sessionStorage without searching again by itself.
export const [useSubmittedTripQuery, SubmittedTripQueryProvider] = createGenericContext<TripQueryState>()
